import { render, staticRenderFns } from "./RatingTemplate.vue?vue&type=template&id=14b8c1c9&scoped=true"
import script from "./RatingTemplate.vue?vue&type=script&lang=js"
export * from "./RatingTemplate.vue?vue&type=script&lang=js"
import style0 from "./RatingTemplate.vue?vue&type=style&index=0&id=14b8c1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8c1c9",
  null
  
)

export default component.exports